<template>
  <div class="container-fluid">
    <div class="page-tabs mt-4">
      <a
        :class="{ active: currentTab === 0 }"
        @click.prevent="
          (currentTab = 0),
            (tableInfo = {
              page: 1,
              per_page: 10,
            })
        "
      >
        排程
      </a>
      <a
        :class="{ active: currentTab === 1 }"
        @click.prevent="
          (currentTab = 1),
            (tableInfo = {
              page: 1,
              per_page: 10,
            })
        "
      >
        同步紀錄
      </a>
    </div>

    <template v-if="currentTab === 0">
      <div class="yahome-table-wrap">
        <VueBootstrap4Table
          :rows="rows"
          :columns="scheduleColumns"
          :config="config"
          :total-rows="scheduleTotalData"
          @on-change-query="onChangeSchedule"
        >
          <template slot="execute" slot-scope="props">
            <button
              class="btn btn-success btn-edit btn-sm"
              style="margin-right: 0.5rem"
              @click="manualExecuteJob(props.row.JobType)"
            >
              立即執行
            </button>
          </template>

          <template slot="setting" slot-scope="props">
            <button
              class="btn btn-info btn-delete btn-sm"
              data-toggle="modal"
              data-target="#settingModal"
              @click="openModal(props.row)"
            >
              排程時間設定
            </button>
          </template>

          <template slot="log" slot-scope="props">
            <button
              class="btn btn-primary btn-delete btn-sm"
              data-toggle="modal"
              data-target="#recordModal"
              @click="getLogRecord(props.row.JobType)"
            >
              執行紀錄
            </button>
          </template>

          <template slot="enabled" slot-scope="props">
            <el-switch
              active-color="#13ce66"
              inactive-color="#808080"
              v-model="props.row.Enabled"
              @change="updateJobSettingEnabled(props.row)"
            >
            </el-switch>
          </template>
          <template slot="empty-results"> 暫無資料 </template>
        </VueBootstrap4Table>
      </div>
    </template>

    <template v-if="currentTab === 1">
      <div class="card search-card">
        <div class="card-body">
          <div class="form-row">
            <div class="col-md-3 col-sm-12">
              <div class="form-group">
                <label for="">同步日期</label>
                <date-picker
                  class="w-100"
                  type="date"
                  range
                  placeholder="YYYY-MM-DD~YYYY-MM-DD"
                  v-model="search.dateRange"
                />
              </div>
            </div>
            <div class="col-md-3 col-sm-12">
              <div class="form-group">
                <label for="">關鍵字</label>
                <input
                  class="form-control"
                  type="text"
                  placeholder="請輸入關鍵字"
                  v-model="search.Keyword"
                />
              </div>
            </div>
            <div class="col-md-2 col-sm-12">
              <div class="form-group">
                <label for="">同步來源</label>
                <select class="form-control" v-model="search.Source">
                  <option :value="null">全部</option>
                  <option value="Email同步履歷">Email 同步履歷</option>
                  <option value="複製104履歷">複製 104履歷</option>
                </select>
              </div>
            </div>
            <div class="col-md-2 col-sm-12">
              <div class="form-group">
                <label for="">同步結果</label>
                <select class="form-control" v-model="search.ExecuteResult">
                  <option :value="null">全部</option>
                  <option value="成功">成功</option>
                  <option value="失敗">失敗</option>
                </select>
              </div>
            </div>
            <div class="col-md-2 col-sm-12">
              <div class="form-group">
                <button
                  type="button"
                  class="btn btn-primary"
                  style="margin-top: 30px; margin-left: 10px"
                  @click="
                    getSyncRecord({
                      page: tableInfo.page,
                      per_page: tableInfo.per_page,
                    })
                  "
                >
                  查詢
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="yahome-table-wrap">
        <VueBootstrap4Table
          :rows="rows"
          :columns="recordColumns"
          :config="recordConfig"
          :total-rows="recordTotalData"
          @on-change-query="onChangeQuery"
        >
          <template slot="empty-results"> 暫無資料 </template>
        </VueBootstrap4Table>
      </div>
    </template>

    <!-- 排程時間 Modal -->
    <div
      id="settingModal"
      class="modal fade"
      tabindex="-1"
      data-focus="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <ValidationObserver
          ref="role"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form @reset.prevent="reset">
            <div class="modal-header">
              <span>排程時間設定</span>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-4">
                  <label for=""> <span class="mark">*</span>排程設定 </label>
                  <select class="form-control" v-model="setting.JobTimeType">
                    <option value="Month">每月</option>
                    <option value="Week">每週</option>
                    <option value="Day">每日</option>
                  </select>

                  <label>
                    <input
                      type="radio"
                      name="timer"
                      :value="false"
                      v-model="setting.IsRepeatPeriod"
                    />
                    執行時間
                  </label>
                  <date-picker
                    v-model="setting.JobTimeSpan"
                    type="time"
                    format="HH:mm:ss"
                    value-type="format"
                    placeholder="請選擇"
                  />

                  <label>
                    <input
                      type="radio"
                      name="timer"
                      :value="true"
                      v-model="setting.IsRepeatPeriod"
                    />
                    重複執行每隔
                  </label>
                  <select
                    class="form-control"
                    v-model="setting.RepeatPeriodMinute"
                  >
                    <option value="0" disabled>請選擇</option>
                    <option value="1">1分鐘</option>
                    <option value="3">3分鐘</option>
                    <option value="5">5分鐘</option>
                    <option value="10">10分鐘</option>
                    <option value="15">15分鐘</option>
                    <option value="30">30分鐘</option>
                    <option value="60">60分鐘</option>
                  </select>
                </div>
                <div class="col-md-8">
                  <div class="month" v-if="setting.JobTimeType === 'Month'">
                    <label v-for="i in 31" :key="i">
                      <input
                        type="checkbox"
                        :value="i"
                        v-model="setting.JobDayOfMonth"
                      />
                      <span>{{ i }}</span>
                    </label>
                  </div>

                  <div class="week" v-if="setting.JobTimeType === 'Week'">
                    <label v-for="i in week" :key="i.value">
                      <input
                        type="checkbox"
                        :value="i.value"
                        v-model="setting.JobDayOfWeek"
                      />
                      <span>{{ i.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="reset"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                {{ i18n("Buttons.Cancel") }}
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="handleSubmit(updateTimeSetting)"
              >
                {{ i18n("Buttons.Save") }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- 執行紀錄 Modal -->
    <div
      id="recordModal"
      class="modal fade"
      tabindex="-1"
      data-focus="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <ValidationObserver ref="role" class="modal-content" v-slot="{ reset }">
          <form @reset.prevent="reset">
            <div class="modal-header">
              <span>執行紀錄</span>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-7 col-sm-12">
                  <div class="form-group">
                    <label for="">查詢日期</label>
                    <date-picker
                      class="w-100"
                      v-model="logDate"
                      value-type="format"
                      format="YYYY-MM-DD"
                      type="date"
                      placeholder="請選擇"
                      @change="getLogRecord(choiceJobType)"
                    />
                  </div>

                  <div class="yahome-table-wrap">
                    <VueBootstrap4Table
                      :rows="logList"
                      :columns="logColumns"
                      :config="logConfig"
                    >
                      <template slot="record" slot-scope="props">
                        <el-button size="mini" @click="choiceRecord(props.row)">
                          紀錄
                        </el-button>
                      </template>

                      <template slot="empty-results">暫無資料</template>
                    </VueBootstrap4Table>
                  </div>
                </div>
                <div class="col-md-5 col-sm-12">
                  <span class="item-type">紀錄</span>
                  <div class="item-list">
                    <span v-if="logRecord.Message">{{
                      logRecord.Message
                    }}</span>
                    <span v-else>尚未有資料</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="reset"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                {{ i18n("Buttons.Cancel") }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { config } from "@/components/back/table_config.js";

export default {
  data() {
    return {
      rows: [],

      // 排程
      scheduleTotalData: 0,
      // 同步紀錄
      recordTotalData: 0,
      // 分頁資訊
      tableInfo: {
        page: 1,
        per_page: 10,
      },

      search: {
        dateRange: [],
        Source: null,
        ExecuteResult: null,
      },

      // tab
      currentTab: 0,

      logRecord: {},

      setting: {},

      // 同步紀錄
      recordColumns: [
        {
          label: "同步時間",
          name: "ExecuteTime",
        },
        {
          label: "主旨/姓名",
          name: "Subject",
        },
        {
          label: "同步結果",
          name: "ExecuteResult",
        },
      ],

      // 排程Columns
      scheduleColumns: [
        {
          label: "排程名稱",
          name: "JobName",
        },
        {
          label: "最近執行時間",
          name: "LastExecuteTime",
        },
        {
          label: "下一次執行時間",
          name: "NextExecuteTime",
        },
        {
          label: "操作",
          name: "execute",
          slot_name: "execute",
        },
        {
          label: "排程時間設定",
          name: "setting",
          slot_name: "setting",
        },
        {
          label: "執行紀錄",
          name: "log",
          slot_name: "log",
        },
        {
          label: "啟用",
          name: "enabled",
          slot_name: "enabled",
        },
      ],

      // 排程Config
      config: {
        ...config,
        server_mode: true,
      },

      recordConfig: {
        ...config,
        server_mode: true,
      },

      // 執行記錄
      logDate: "",
      logList: [],

      // 執行記錄Columns
      logColumns: [
        {
          label: "開始時間",
          name: "StartTime",
          slot_name: "StartTime",
        },
        {
          label: "結束時間",
          name: "EndTime",
          slot_name: "EndTime",
        },
        {
          label: "狀態",
          name: "Status",
        },
        {
          label: "紀錄",
          name: "record",
          slot_name: "record",
        },
      ],

      // 執行記錄Config
      logConfig: {
        global_search: {
          visibility: false,
        },

        show_refresh_button: false,
        show_reset_button: false,

        pagination: true,
        pagination_info: false,
        num_of_visibile_pagination_buttons: 5,
        per_page: 5,
        per_page_options: [5],
        selected_rows_info: false,

        highlight_row_hover: false,
        rows_selectable: true,
        multi_column_sort: false,
        card_mode: false,
      },

      // 排程時間設定
      week: [
        {
          label: "星期一",
          value: "1",
        },
        {
          label: "星期二",
          value: "2",
        },
        {
          label: "星期三",
          value: "3",
        },
        {
          label: "星期四",
          value: "4",
        },
        {
          label: "星期五",
          value: "5",
        },
        {
          label: "星期六",
          value: "6",
        },
        {
          label: "星期日",
          value: "0",
        },
      ],
    };
  },

  watch: {
    currentTab: function (e) {
      e === 0
        ? this.getJobSetting({
            page: this.tableInfo.page,
            per_page: this.tableInfo.per_page,
          })
        : this.getSyncRecord({
            page: this.tableInfo.page,
            per_page: this.tableInfo.per_page,
          });
    },
  },

  methods: {
    onChangeSchedule(queryParams) {
      const vm = this;
      vm.tableInfo = queryParams;
      vm.getJobSetting({
        page: vm.tableInfo.page,
        per_page: vm.tableInfo.per_page,
      });
    },

    // 換頁
    onChangeQuery(queryParams) {
      const vm = this;
      vm.tableInfo = queryParams;
      vm.getSyncRecord({
        page: vm.tableInfo.page,
        per_page: vm.tableInfo.per_page,
      });
    },

    // 取得同步紀錄
    getSyncRecord({ page, per_page }) {
      const vm = this;
      const api = `${window.endpoints.api}/RPA/Record`;

      let startDate = null,
        endDate = null;

      if (vm.search.dateRange.length > 0) {
        startDate = vm.search.dateRange[0]
          ? vm.dayjs(vm.search.dateRange[0]).format("YYYY-MM-DD")
          : null;

        endDate = vm.search.dateRange[1]
          ? vm.dayjs(vm.search.dateRange[1]).format("YYYY-MM-DD")
          : null;
      }

      const params = {
        ...vm.search,
        ExecuteDateStart: startDate,
        ExecuteDateEnd: endDate,
        IsPaging: true,
        page: page,
        perPage: per_page,
      };

      vm.$store.dispatch("updateLoading", true);

      vm.$http
        .get(api, { params })
        .then((response) => {
          if (response.status === 200) {
            vm.rows = response.data.Datas.map((item) => {
              return {
                ...item,
                ExecuteTime: item.ExecuteTime
                  ? vm.dayjs(item.ExecuteTime).format("YYYY-MM-DD HH:mm")
                  : null,
              };
            });
            vm.recordTotalData = response.data.Quantity;

            vm.$nextTick(() => {
              vm.$store.dispatch("updateLoading", false);
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "錯誤",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 該排程執行記錄
    getLogRecord(JobType) {
      const vm = this;
      const api = `${window.endpoints.api}/RPA/JobSetting/JobRecord`;

      if (vm.choiceJobType !== JobType) {
        vm.logDate = this.dayjs().format("YYYY-MM-DD");
      }

      vm.choiceJobType = JobType;
      const params = {
        jobType: vm.choiceJobType,
        date: vm.logDate,
      };

      vm.logRecord = {};

      vm.$store.dispatch("updateLoading", true);

      vm.$http
        .get(api, { params })
        .then((response) => {
          if (response.status === 200) {
            vm.logList = response.data.map((item) => {
              return {
                ...item,
                StartTime: item.StartTime
                  ? vm.dayjs(item.StartTime).format("YYYY-MM-DD HH:mm")
                  : null,
                EndTime: item.EndTime
                  ? vm.dayjs(item.EndTime).format("YYYY-MM-DD HH:mm")
                  : null,
              };
            });
            vm.$store.dispatch("updateLoading", false);
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "錯誤",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 立即執行
    manualExecuteJob(JobType) {
      const vm = this;
      const api = `${window.endpoints.api}/RPA/JobSetting/ManualExecuteJob`;

      const data = {
        createUser: vm.$cookies.get("userId"),
        JobType: JobType,
      };

      vm.$store.dispatch("updateLoading", true);
      vm.$http
        .post(api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            vm.$notify({
              title: "成功",
              message: "已執行排程",
              type: "success",
              duration: 2500,
            });

            vm.getJobSetting({
              page: vm.tableInfo.page,
              per_page: vm.tableInfo.per_page,
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "錯誤",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 排程時間設定Modal
    openModal(item) {
      this.setting = {
        ...item,
        JobDayOfWeek:
          item.JobDayOfWeek !== null ? item.JobDayOfWeek.split(",") : [],
        JobDayOfMonth:
          item.JobDayOfMonth !== null ? item.JobDayOfMonth.split(",") : [],
      };
    },

    // 取得排程data
    getJobSetting() {
      const vm = this;
      const api = `${window.endpoints.api}/RPA/JobSetting`;

      vm.$store.dispatch("updateLoading", true);
      vm.$http
        .get(api)
        .then((response) => {
          if (response.status === 200) {
            vm.rows = response.data.Datas.map((item) => {
              return {
                ...item,
                LastExecuteTime: item.LastExecuteTime
                  ? vm.dayjs(item.LastExecuteTime).format("YYYY-MM-DD HH:mm")
                  : null,
                NextExecuteTime: item.NextExecuteTime
                  ? vm.dayjs(item.NextExecuteTime).format("YYYY-MM-DD HH:mm")
                  : null,
                Status: item.Status === "Running" ? "忙碌" : "閒置",
              };
            });
            vm.scheduleTotalData = response.data.Quantity;

            vm.$nextTick(() => {
              vm.$store.dispatch("updateLoading", false);
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "提醒",
            message: error.response.data,
            type: "warning",
            duration: 3500,
          });
        });
    },

    // 排程時間設定
    updateTimeSetting() {
      const vm = this;
      const api = `${window.endpoints.api}/RPA/JobSetting/TimeSetting`;

      const data = {
        Id: vm.setting.Id,
        UpdateUser: vm.$cookies.get("userId"),
        JobTimeType: vm.setting.JobTimeType,
        JobDayOfWeek:
          vm.setting.JobTimeType === "Week" ? vm.setting.JobDayOfWeek : null,
        JobDayOfMonth:
          vm.setting.JobTimeType === "Month" ? vm.setting.JobDayOfMonth : null,
        IsRepeatPeriod: vm.setting.IsRepeatPeriod,
        JobTimeSpan: vm.setting.JobTimeSpan,
        RepeatPeriodMinute: vm.setting.RepeatPeriodMinute,
      };

      $("#settingModal").modal("hide");
      vm.$store.dispatch("updateLoading", true);
      vm.$http
        .put(api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);
            vm.$notify({
              title: "成功",
              message: "已設定排程時間",
              type: "success",
              duration: 2500,
            });

            vm.getJobSetting({
              page: vm.tableInfo.page,
              per_page: vm.tableInfo.per_page,
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "錯誤",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 執行記錄table的記錄
    choiceRecord(record) {
      this.logRecord = record;
    },

    // 排程啟用
    updateJobSettingEnabled(item) {
      const vm = this;
      const api = `${window.endpoints.api}/RPA/JobSetting/Enabled`;

      const data = {
        Id: item.Id,
        UpdateUser: vm.$cookies.get("userId"),
        Enabled: item.Enabled,
      };

      vm.$store.dispatch("updateLoading", true);
      vm.$http
        .put(api, data)
        .then((response) => {
          if (response.status === 200) {
            vm.$store.dispatch("updateLoading", false);

            vm.$notify({
              title: "成功",
              message: data.Enabled ? "已啟用排程" : "已關閉排程",
              type: "success",
              duration: 2000,
            });

            vm.getJobSetting({
              page: vm.tableInfo.page,
              per_page: vm.tableInfo.per_page,
            });
          }
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          vm.$notify({
            title: "錯誤",
            message: error.response.data,
            type: "error",
            duration: 3500,
          });
        });
    },

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  created() {
    this.getJobSetting({
      page: this.tableInfo.page,
      per_page: this.tableInfo.per_page,
    });
    this.search.dateRange = [
      new Date(this.$common.getToday()),
      new Date(this.$common.getToday()),
    ];
    this.logDate = this.dayjs().format("YYYY-MM-DD");
  },
};
</script>

<style lang="scss" scoped>
.page-tabs {
  cursor: pointer;
}

.modal-dialog {
  min-width: 800px;
}

.month {
  display: flex;
  flex-wrap: wrap;

  span {
    width: 40px;
    border-radius: 6px;
    margin-bottom: 1rem;
    text-align: center;
  }

  label {
    margin: 0 4px;
  }
}

.week {
  display: flex;
  flex-wrap: wrap;

  span {
    width: 110px;
    border-radius: 6px;
    margin-bottom: 1rem;
    text-align: center;
  }

  label {
    margin: 0 4px;
  }
}

.col-md-4 {
  border-right: 1px solid #f1f1f1;
}

.form-control {
  margin-bottom: 1rem;
}

.mx-datepicker {
  width: 100%;
  height: 38px;
  margin-bottom: 1rem;
}

label {
  padding: 0;
  margin-right: 3px;
  cursor: pointer;
}
input[type="checkbox"] {
  display: none;
}
input[type="checkbox"] + span {
  display: inline-block;
  background-color: #d3d3d3;
  padding: 3px 6px;
  border: 1px solid gray;
  color: #333;
  user-select: none; /* 防止文字被滑鼠選取反白 */
}

input[type="checkbox"]:checked + span {
  color: #fff;
  background-color: #5380f7;
}

#recordModal .modal-dialog {
  min-width: 900px;
}

.item-type {
  background-color: white;
  color: #33344a;
  padding: 3px 10px;
  position: absolute;
  top: -22px;
  left: 30px;
}

.item-list {
  height: 100%;
  overflow: auto;
  border: 2px solid #33344a;
  border-radius: 5px;
  padding: 10px;
  font-size: 14px;
}

.form-group {
  label {
    font-size: 0.8em;
  }
}

.yahome-table-wrap {
  padding: 0;
}
</style>
